import { tokens } from "shared/components/Spor";
import styled from "styled-components";

/**
 * Shared layout for the alternative transport left/right panels
 */

export const PanelHorizontalScroll = styled.div`
  flex: 1;
  min-height: 0;
  margin-right: -${tokens.default.size.spacing[2.5]};
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const PanelScrollContent = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 924px;
  display: flex;
  flex-direction: column;
  gap: ${tokens.default.size.spacing[2]};

  @container altTransportPage (width < 1696px) {
    min-width: 0;
  }
`;

export const PanelScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: none;
  display: flex;
  flex-direction: column;
  gap: ${tokens.default.size.spacing[2]};
  padding-top: ${tokens.default.size.spacing[3]};
  padding-right: ${tokens.default.size.spacing[2.5]};
`;

export const PanelModuleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(456px, 812px));
  gap: ${tokens.default.size.spacing[2]};
  align-items: start;
  padding-bottom: ${tokens.default.size.spacing[3]};

  @container altTransportPage (width < 1696px) {
    grid-template-columns: 1fr;
  }
`;

export const PanelHeaderDivider = styled.div`
  flex-shrink: 0;
  margin: 0 -${tokens.default.size.spacing[3]};
  padding: ${tokens.default.size.spacing[3]};
  border-bottom: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
`;
